import { IkeEnvironment } from '@ikegps/core-api';
import { IkeConfig, IkeConfigStore, IkeId } from '@ikegps/core-shared';
import { type IkeClientService, Services } from './index';

export class ConfigService implements IkeClientService {
	__priority = 5;

	applicationId: string;
	env: IkeEnvironment;

	private _config: IkeConfig;

	get config(): IkeConfig {
		if (this._config) {
			return this._config;
		}

		this.env = Services.Window.window.IKE_ENVIRONMENT;
		const configFromWindow = Services.Window.window.IKE_CONFIG;

		this._config = new IkeConfig('office', this.env, configFromWindow);
		this._config.set('application.name', 'IkeOffice');
		this._config.set('application.url', '');

		switch (this._config.env) {
			case IkeEnvironment.PRODUCTION:
				this._config.set('som.url', 'https://span-o-matic.ikegps.com');
				break;
			case IkeEnvironment.STAGING:
				this._config.set('som.url', 'https://staging-span-o-matic.ikegps.net');
				break;
			case IkeEnvironment.TEST:
			case IkeEnvironment.TEST2:
			case IkeEnvironment.AUTOMATION:
			case IkeEnvironment.DEV:
				this._config.set('som.url', 'https://test-span-o-matic.ikegps.net');
				break;
			default:
				this._config.set('som.url', 'http://localhost:1234');
		}

		this._config.set('application.version', Services.Window.window.IKE_APPLICATION_VERSION);

		IkeId.getBytes = (size: number): Uint8Array => {
			const array = new Uint8Array(size);
			crypto.getRandomValues(array);
			return array;
		};
		IkeConfigStore.fetch = window.fetch.bind(window);

		return this._config;
	}
}
